<template lang="pug">  
    el-breadcrumb(separator="/")                  
        el-breadcrumb-item.breadcrumb-item Estás en: {{currentLesson.title}}
        el-breadcrumb-item.breadcrumb-item {{currentGroup.title}}
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'BreadCrumb',
  computed: {
      ...mapGetters(['currentLesson', 'currentGroup'])
  },
}
</script>

<style scoped>
@import 'breadcrumb.scss';
</style>

